import { r as registerInstance, c as createEvent, h, g as getElement } from './core-6f498fd9.js';
var CsmRadioGroup = /** @class */ (function () {
    function CsmRadioGroup(hostRef) {
        registerInstance(this, hostRef);
        this.csmChange = createEvent(this, "csmChange", 7);
    }
    CsmRadioGroup.prototype.onRadioChange = function (event) {
        this.children.forEach(function (radio) {
            radio.checked = radio.value === event.detail.value;
        });
        this.csmChange.emit(event.detail.value);
    };
    CsmRadioGroup.prototype.componentDidRender = function () {
        this.children = Array.from(this.host.querySelectorAll('csm-radio-button'));
    };
    CsmRadioGroup.prototype.render = function () {
        return h("slot", null);
    };
    Object.defineProperty(CsmRadioGroup.prototype, "host", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    return CsmRadioGroup;
}());
export { CsmRadioGroup as csm_radio_group };
